import { Component } from '@angular/core';

@Component({
  selector: 'admin-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  github = 'https://github.com/ksmai/admin-template';
  rubix = 'http://rubix410.sketchpixy.com/ltr/dashboard';
  author = 'ksmai';
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts